import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import { LazyImg } from './LazyImg';
import { Typography } from './Typography';

const RootLink = styled.a`
  width: 300px;

  background: ${theme.colors.neutral[100]};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  transition: all 200ms ease-in;

  ${legacyTheme.breakpoints.match('md')} {
    width: 230px;
  }

  ${legacyTheme.breakpoints.match('sm')} {
    width: 100%;

    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }

  &:hover {
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.05);
    transition: all 200ms ease-in;

    & img {
      top: -5%;
      left: -5%;
      transition: all 200ms ease-in;

      width: 110%;
    }
  }
`;

const ImageWrapper = styled.span`
  display: block;
  width: 100%;
  height: 200px;
  overflow: hidden;
`;

const Image = styled(LazyImg)`
  position: relative;
  top: 0;
  left: 0;

  width: 100%;

  transition: all 200ms ease-in;
`;

const Content = styled.div`
  width: 100%;
  padding: 20px 30px;
`;

const Subtitle = styled(Typography)`
  margin-top: 12px;
`;

const BlogCard = ({ image, imageAlt, category, subtitle, title, url }) => {
  return (
    <RootLink href={url} rel="noopener noreferrer" target="_blank">
      <ImageWrapper>
        <Image alt={imageAlt} src={image.src} />
      </ImageWrapper>

      <Content>
        <Typography align="left" color="grey" paragraph variant="mono2">
          {category}
        </Typography>

        <Typography align="left" color="noir" paragraph variant="h3">
          {title}
        </Typography>

        {subtitle && (
          <Subtitle align="left" color="grey" paragraph variant="p3">
            {subtitle}
          </Subtitle>
        )}
      </Content>
    </RootLink>
  );
};

BlogCard.propTypes = {
  category: PropTypes.string.isRequired,
  image: srcOrNextImageProp.isRequired,
  imageAlt: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

BlogCard.defaultProps = {
  subtitle: null,
};

export default BlogCard;
